import { render, staticRenderFns } from "./rejectAndStopModal.vue?vue&type=template&id=3248d006&scoped=true"
import script from "./rejectAndStopModal.vue?vue&type=script&lang=js"
export * from "./rejectAndStopModal.vue?vue&type=script&lang=js"
import style0 from "./rejectAndStopModal.vue?vue&type=style&index=0&id=3248d006&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248d006",
  null
  
)

export default component.exports